export default "__VITE_ASSET__DZrRujsD__"